<!-- Table -->
<div
  class="spinner-border"
  role="status"
  *ngIf="isLoading$ | async"
  attr.aria-label="{{ 'wcag.loading' | translate }}"
></div>

<div
  class="table-responsive"
  id="matches-table"
  *ngIf="(matches$ | async)?.length && !(isLoading$ | async)"
>
  <table class="table table-borderless table-nowrap">
    <thead class="table-light">
      <tr>
        <th scope="col">{{ 'general.date' | translate }}</th>
        <th scope="col">{{ 'general.location' | translate }}</th>
        <th scope="col">{{ 'competitionModule.referee' | translate }}</th>
        <th scope="col">{{ 'competitionModule.teams' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let match of matches$ | async; let i = index">
        <td>
          <span *ngIf="!(isSameBookingDay$(i) | async)"
            ><strong
              >{{
                (bookingEntities$ | async)[match.bookingId]?.startDate
                  | formatDate : 'd MMM y'
                  | async
              }}
            </strong>
            <br />
          </span>

          {{
            (bookingEntities$ | async)[match.bookingId]?.startDate
              | date : 'HH:mm'
          }}
        </td>
        <td>
          {{
            (productEntities$ | async)[
              (bookingEntities$ | async)[match.bookingId]?.productId
            ]?.id
              | getTranslation : 'product' : 'description'
              | async
              | slice : 0 : 10
          }}
        </td>
        <td>
          <span
            *ngIf="
              (competitionTeamEntities$ | async)[match.memberId * -1];
              else noReferee
            "
          >
            {{
              (competitionTeamEntities$ | async)[match.memberId * -1]
                ? (competitionTeamEntities$ | async)[match.memberId * -1]
                    ?.description
                : (memberEntities$ | async)[
                    (competition$ | async)?.competitionLeaderPersonId
                  ]?.firstName +
                  ' ' +
                  (memberEntities$ | async)[
                    (competition$ | async)?.competitionLeaderPersonId
                  ]?.middleName +
                  ' ' +
                  (memberEntities$ | async)[
                    (competition$ | async)?.competitionLeaderPersonId
                  ]?.lastName
            }}
          </span>
          <ng-template #noReferee>
            <span> - </span>
          </ng-template>
        </td>
        <td>
          <span
            [ngClass]="{
              'fw-bold': match.team1Id == team?.id
            }"
            >{{
              (competitionTeamEntities$ | async)[match.team1Id]?.description
            }}
          </span>
          -
          <span
            [ngClass]="{
              'fw-bold': match.team2Id == team?.id
            }"
            >{{
              (competitionTeamEntities$ | async)[match.team2Id]?.description
            }}</span
          >
        </td>
      </tr>
    </tbody>
  </table>
</div>
<!-- End Table -->
<div *ngIf="!(matches$ | async)?.length && !(isLoading$ | async)" class="p-4">
  <span *ngIf="!competitionId">{{
    'competitionModule.teamHasNoUpcomingMatches' | translate
  }}</span>
  <span *ngIf="competitionId">{{
    'competitionModule.competitionHasNoUpcomingMatches' | translate
  }}</span>
</div>
